module.exports = __webpack_public_path__ + "media/components/country-flag/static/vg-bd3c0c187156b610e3a64cad99298829.svg";